(function () {
  function initDiscoverSlider(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.discover__tab'));
    var grid = root.querySelector('.discover__grid');
    var emptyMessage = root.querySelector('.discover__empty');
    if (!tabs.length || !grid) return;

    var currentHandle = root.dataset.productHandle;
    var currentType = root.dataset.productType;
    var searchUrl = root.dataset.searchUrl;
    var cardStyle = root.dataset.cardStyle;

    var recommendedHtml = grid.innerHTML;
    var templates = {};
    root.querySelectorAll('template[data-discover-template]').forEach(function (template) {
      templates[template.dataset.discoverTemplate] = template.innerHTML;
    });

    var typeHtmlPromise = null;

    function renderGrid(html) {
      grid.innerHTML = html;
      var hasResults = grid.children.length > 0;
      grid.hidden = !hasResults;
      if (emptyMessage) emptyMessage.hidden = hasResults;
      if (typeof root.resetPages === 'function') {
        root.resetPages();
      }
    }

    function fetchTypeMatches() {
      if (typeHtmlPromise) return typeHtmlPromise;

      var query = 'product_type:"' + currentType + '"';
      var url =
        searchUrl +
        '?q=' +
        encodeURIComponent(query) +
        '&type=product&section_id=discover-type-search&exclude=' +
        encodeURIComponent(currentHandle);
      if (cardStyle) {
        url += '&card=' + encodeURIComponent(cardStyle);
      }

      typeHtmlPromise = fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (text) {
          var container = document.createElement('div');
          container.innerHTML = text;
          var list = container.querySelector('.discover__cards-response');
          return list ? list.innerHTML : '';
        })
        .catch(function (err) {
          console.error('[discover-tabs] Failed to load "More ' + currentType + '" results:', err);
          return '';
        });

      return typeHtmlPromise;
    }

    function showTab(tabKey) {
      tabs.forEach(function (tab) {
        var isActive = tab.dataset.tab === tabKey;
        tab.classList.toggle('discover__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (tabKey === 'recommended') {
        renderGrid(recommendedHtml);
        return;
      }

      if (tabKey === 'type') {
        grid.setAttribute('aria-busy', 'true');
        fetchTypeMatches().then(function (html) {
          renderGrid(html);
          grid.removeAttribute('aria-busy');
        });
        return;
      }

      renderGrid(templates[tabKey] || '');
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('discover__tab--active')) return;
        showTab(tab.dataset.tab);
      });
    });
  }

  function tryInit(root) {
    if (root.dataset.discoverInitialized) return;
    root.dataset.discoverInitialized = 'true';
    initDiscoverSlider(root);
  }

  // <product-recommendations> (global.js) fetches fresh HTML once it
  // scrolls into view and swaps it in with this.innerHTML = ... — that
  // discards the server-rendered .discover__slider this script ran
  // against on first parse, and replaces it with a new copy whose
  // <script> tag never executes (assigning innerHTML never runs embedded
  // scripts). Watching for it to (re)appear and initializing it each time
  // is the only way to keep working after that swap.
  document.querySelectorAll('slider-component.discover__slider').forEach(tryInit);

  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('slider-component.discover__slider')) {
          tryInit(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('slider-component.discover__slider').forEach(tryInit);
        }
      });
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
